<div (clickOutside)="shouldClose.emit()" [delayClickOutsideInit]="true">
  <div class="inputs-container">
    <wm-front-input-date
      [ngModel]="selectedRangeValue.start"
      (ngModelChange)="onStartDateInputted($event, calendar)"
    ></wm-front-input-date>
    <wm-front-input-date
      [ngModel]="selectedRangeValue.end"
      (ngModelChange)="onEndDateInputted($event, calendar)"
    ></wm-front-input-date>
  </div>
  @if (displayMaxRange) {
  <div
    class="warning-range"
    i18n="
      Warning label | label for the warning max
      range@@dateRangePickerWarningLabel"
  >
    Merci de sélectionner {{ maxMonthRange }} mois au maximum
  </div>
  }
  <div class="shortcuts">
    <button
      wm-front-button
      i18n="@@dateRangePickerTodayLabel"
      (click)="shortcut()"
      [size]="'small'"
      status="transparent"
    >
      Today
    </button>
    <button
      wm-front-button
      i18n="@@dateRangePickerLast7DaysLabel"
      (click)="shortcut(7)"
      [size]="'small'"
      status="transparent"
    >
      Last 7 days
    </button>
    <button
      wm-front-button
      i18n="@@dateRangePickerLastMonthLabel"
      (click)="shortcut(30)"
      [size]="'small'"
      status="transparent"
    >
      Last month
    </button>
  </div>
  <mat-calendar
    #calendar
    [startAt]="startDate"
    [selected]="selectedRangeValue"
    [headerComponent]="headerComponent"
    (selectedChange)="selectedChange($event)"
  >
  </mat-calendar>
  <div
    class="reset"
    [class.resetMode]="selectedRangeValue.start && activeResetBtn"
    [class.disabled]="
      !selectedRangeValue.start && !selectedRangeValue.end && !activeResetBtn
    "
    (click)="resetPeriod()"
  >
    <p
      i18n="
        Button label | label for the reset button in the autocomplete dropdown
        component@@autoCompleteDropdownResetActionButton"
    >
      Réinitialiser
    </p>
  </div>
</div>
